<template lang="pug">
form.form-horizontal
  h3.box-title.m-b-0(style='text-align:center;margin:10px') オブジェクト {{ index + 1 }}
  .form-group
    label.col-md-12 サブタイトル
    .col-md-12
      div(@keyup='setContent')
        el-input(type='text', v-model='formdata.subtitle', placeholder='画面上には表示されません（コンテンツの識別に使います）')
  .form-group
    label.col-md-12 本文
    .col-md-12
      div(@keyup='setContent')
        el-input(type='textarea', v-model='formdata.body', :rows='5')
  .form-group(v-show='imagesShow')
    label.col-md-12 登録済み画像・動画
    el-table(:data='formdata.images')
      el-table-column(label="image", width="300")
        template(slot-scope="scope")
          img(v-if='scope.row.file_type=="image"', :src='scope.row.image_url', height='128')
          video(v-if='scope.row.file_type=="video"', :src='scope.row.image_url', height='128')
      el-table-column(property="image_url", label="image_url", width="200")
      el-table-column(label="caption")
        template(slot-scope="scope")
          el-input(v-model='scope.row.caption', placeholder='キャプション')
      el-table-column(fixed='right', label='Operations', width='200')
        template(slot-scope='scope')
          el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveImgUp(scope.$index)')
          el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveImgDown(scope.$index)')
          el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index)') 
  .form-group
    label.col-md-12 新規画像・動画
      span(style='margin: 20px')
        el-button(type='primary', icon='el-icon-plus', size='mini', v-on:click='onBtnSubFileAdd')
    el-table(:data='formdata.uploadedImages')
      el-table-column(label="image", width="300")
        template(slot-scope="scope")
          img(v-if='scope.row.file_type=="image"', :src='scope.row.image', height='128')
          video(v-if='scope.row.file_type=="video"', :src='scope.row.image', height='128')
      el-table-column(property="name", label="name", width="200")
      el-table-column(label="caption")
        template(slot-scope="scope")
          div(@keyup='setCaption(scope.row.caption, scope.$index)')
            el-input(v-model='scope.row.caption', placeholder='キャプション')
      el-table-column(fixed='right', label='Operations', width='200')
        template(slot-scope='scope')
          el-button(size='mini', type='primary', icon='el-icon-caret-top', circle, @click='moveNewImgUp(scope.$index)')
          el-button(size='mini', type='primary', icon='el-icon-caret-bottom', circle, @click='moveNewImgDown(scope.$index)')
          el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteSubConfirm(scope.$index)') 
    input(:id='imgIndex + index', type='file', style='visibility: hidden', v-on:change='onSubFileAdd($event)')
  .deleteBtn
    el-button(type='danger', icon='el-icon-delete', @click='deleteObject') 
</template>

<script>
import axios from 'axios'
import PublicSetting from '@/views/components/swan/common/PublicSetting'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Top',
  data () {
    return {
      formdata: {
        subtitle: '',
        body: '',
        images: [],
        uploadedImages: []
      },
      imageCount: 0,
      subImageCount: 0,
      imgIndex: 'imgIndex',
      deleteObj: 'deleteObj',
      imagesShow: true
    }
  },
  created () {
    // console.log(this.index)
    // console.log(this.formdata)
    // console.log(this.objectFormdata)
    if (this.objectFormdata.objects[this.index].subtitle) {
      this.formdata.subtitle = this.objectFormdata.objects[this.index].subtitle
    } else {
      this.objectFormdata.objects[this.index].subtitle = ''
    }
    if (this.objectFormdata.objects[this.index].body) {
      this.formdata.body = this.objectFormdata.objects[this.index].body
    } else {
      this.objectFormdata.objects[this.index].body = ''
    }
    if (this.objectFormdata.objects[this.index].images) {
      this.formdata.images = this.objectFormdata.objects[this.index].images
    } else {
      this.objectFormdata.objects[this.index].images = []
    }
    if (this.objectFormdata.objects[this.index].uploadedImages) {
      this.formdata.uploadedImages = this.objectFormdata.objects[this.index].uploadedImages
    } else {
      this.objectFormdata.objects[this.index].uploadedImages = []
    }
    if (!this.objectFormdata.objects[this.index].subtitle && !this.objectFormdata.objects[this.index].body) {
      this.imagesShow = false
    }
    console.log(this.GET_OVERVIEW)
    // console.log(this.objectFormdata.objects[this.index].subtitle)
    // console.log(this.imagesShow)
  },
  props: {
    index: {
      default: 0
    },
    objectFormdata: Object
  },
  components: {
    PublicSetting
  },
  watch: {
    'formdata.uploadedImages': function (val) {
      // console.log(1)
      // console.log(val)
      // console.log(this.formdata.uploadedImages)
      let obj = {
        index: this.index,
        data: this.formdata
      }
      // console.log(obj)
      let obj2 = JSON.stringify(obj)
      this.SAVE_OVERVIEW_OBJECT(JSON.parse(obj2))
      this.objectFormdata.objects[this.index] = this.GET_OVERVIEW[this.index]
      console.log(this.GET_OVERVIEW)
    },
    'objectFormdata.objects': function (val) {
      if (this.objectFormdata.objects[this.index].subtitle) {
        this.formdata.subtitle = this.objectFormdata.objects[this.index].subtitle
      }
      if (this.objectFormdata.objects[this.index].body) {
        this.formdata.body = this.objectFormdata.objects[this.index].body
      }
      if (this.objectFormdata.objects[this.index].images) {
        this.formdata.images = this.objectFormdata.objects[this.index].images
      }
      if (this.objectFormdata.objects[this.index].uploadedImages) {
        this.formdata.uploadedImages = this.objectFormdata.objects[this.index].uploadedImages
      }
      if (!this.objectFormdata.objects[this.index].subtitle && !this.objectFormdata.objects[this.index].body) {
        this.imagesShow = false
      }
    }
  },
  mounted: function () {
  },
  methods: {
    deleteConfirm (index) {
      this.$confirm(this.formdata.images[index].name + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.images.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteSubConfirm (index) {
      this.$confirm(this.formdata.uploadedImages[index].name + 'を削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.uploadedImages.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteObject () {
      this.$emit('deleteObj', this.index)
      console.log(this.index)
      // this.$confirm('オブジェクトを削除しますか？', 'Warning', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning',
      //   center: true
      // }).then(() => {
      //   console.log(this.index)
      //   this.objectFormdata.objects.splice(this.index, 1)
      //   this.DELETE_OVERVIEW_OBJECT(this.index)
      //   console.log(this.objectFormdata.objects)
      //   console.log(this.GET_OVERVIEW)
      //   this.$message({
      //     type: 'success',
      //     message: 'Delete completed'
      //   })
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: 'Delete canceled'
      //   })
      // })
      // console.log(this.objectFormdata.objects)
    },
    onBtnFileAdd (e) {
      this.formdata.images.push({})
    },
    onBtnSubFileAdd (e) {
      document.getElementById('imgIndex' + this.index).click()
    },
    onSubFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      // console.log(files)
      if (files[0].type.match(/image/i) || files[0].type.match(/video/i)) {
        let fileType = files[0].type.match(/image/i) ? 'image' : 'video'
        let reader = new FileReader()
        reader.onload = (r) => {
          this.formdata.uploadedImages.push({ name: files[0].name, tag: '__REP_SUBIMG_' + this.subImageCount + '__', image: r.target.result, caption: '', file_type: fileType })
        }
        // console.log(this.formdata)
        this.subImageCount++
        reader.readAsDataURL(files[0])
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    },
    register: function () {
      let inputData = JSON.stringify(this.formdata)
      console.log(inputData)
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/news',
        method: 'POST',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setContent (x) {
      let obj = {
        index: this.index,
        data: this.formdata
      }
      let obj2 = JSON.stringify(obj)
      this.SAVE_OVERVIEW_OBJECT(JSON.parse(obj2))
      // console.log(this.GET_OVERVIEW)
      this.objectFormdata.objects[this.index] = this.GET_OVERVIEW[this.index]
      console.log(this.GET_OVERVIEW)
    },
    setCaption (value, index) {
      console.log(1)
      // console.log(index)
      // console.log(value)
      this.formdata.uploadedImages[index].caption = value
      // console.log(this.formdata.uploadedImages)
      let obj = {
        index: this.index,
        data: this.formdata
      }
      let obj2 = JSON.stringify(obj)
      this.SAVE_OVERVIEW_OBJECT(JSON.parse(obj2))
      this.objectFormdata.objects[this.index] = this.GET_OVERVIEW[this.index]
      // console.log(this.objectFormdata)
      console.log(this.GET_OVERVIEW)
    },
    moveImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.images[orgIndex])
        this.formdata.images = tmp
      }
    },
    moveImgDown (orgIndex) {
      if (orgIndex < this.formdata.images.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.images.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.images[orgIndex])
        this.formdata.images = tmp
      }
    },
    moveNewImgUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.uploadedImages[orgIndex])
        this.formdata.uploadedImages = tmp
      }
    },
    moveNewImgDown (orgIndex) {
      if (orgIndex < this.formdata.uploadedImages.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.uploadedImages.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.uploadedImages[orgIndex])
        this.formdata.uploadedImages = tmp
      }
    },
    ...mapActions([
      'SAVE_OVERVIEW_OBJECT'
    ]),
    ...mapMutations([
      'DELETE_OVERVIEW_OBJECT',
      'SET_OVERVIEW_OBJECT'
    ])
  },
  computed: {
    ...mapGetters([
      'GET_OVERVIEW'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form {
  border: 1px solid #DDDDDD;
  background-color: #F5F5F5;
  margin-bottom:20px;
}
.deleteBtn {
  width: 100px;
  margin:0px auto;
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/overview/addObject.vue